import { Component, Input, OnInit } from '@angular/core';
import { FormItemBase } from '../../models/form-item-base';
import { FormItemControlService } from '../../services/form-item-control.service';
import { FormControl, FormGroup, Validators, ControlContainer } from '@angular/forms';
import { FormItemTitle } from 'src/app/models/form-item-title';
import { FormItemString } from 'src/app/models/form-item-string';
import { FormItemCategory } from 'src/app/models/form-item-category';
import { FormItemButton } from 'src/app/models/form-item-button';
import { FormItemTextBox } from 'src/app/models/form-item-textbox';
import { FormItemIntTextBox } from 'src/app/models/form-item-int-textbox';
import { FormItemDropdown } from 'src/app/models/form-item-dropdown';
import { FormItemCheckbox } from 'src/app/models/form-item-checkbox';
import { FormItemMultiLineTextBox } from 'src/app/models/form-item-multiline-textbox';
import { formLayoutEnum } from 'src/app/services/formLayoutEnum';
import { diagnosisStatusEnum } from 'src/app/services/diagnosisStatusEnum';
import { AppInfoService } from 'src/app/shared/services';
import { stringify } from 'querystring';
import { FormItemBoolList } from 'src/app/models/form-item-boollist';
import { FormItemIntList } from 'src/app/models/form-item-intlist';
//import { E2BIG } from 'constants';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {
  formItemControlService: FormItemControlService;
  appInfoService: AppInfoService;
  bExpandDiagnosis = false;
  formItems = new Array();
  resultItems = new Array();
  diagnosisItems = new Array();
  tabsDataSource = new Array();
  showWorksheetTab = true;
  diagnosisStatus = diagnosisStatusEnum.Unknown;
  diagnosisStatusMessage = '';
  bShowStatusMessage = false;
  bIsLoading: boolean;
  errorList: Array<any>;
  errorListWindowSize = '0';

  form: FormGroup;
  resultsForm: FormGroup;
  diagnosisForm: FormGroup;
  payLoad = '';
  public FormLayout = formLayoutEnum;
  public formLayout: formLayoutEnum;

  constructor(private fcs: FormItemControlService, private ais: AppInfoService) {
    this.formItemControlService = fcs;
    this.appInfoService = ais;
    console.log('DynamicFormComponent constructor');

    this.formLayout = formLayoutEnum.FullScreen;

    // watch for changes to layout
    this.formItemControlService.getFormLayoutObservable().subscribe(formLayout => this.formLayout = formLayout);

    this.formItemControlService.getDiagnosisStatusObservable().subscribe(status => {
      this.diagnosisStatus = status;
      this.bShowStatusMessage = (this.diagnosisStatus !== diagnosisStatusEnum.OK);
    });

    this.formItemControlService.getDiagnosisStatusMessageObservable().subscribe(msg => this.diagnosisStatusMessage = msg);

    this.formItemControlService.getFormLoadingObservable().subscribe(bIsLoading => this.bIsLoading = bIsLoading);

    this.formItemControlService.getErrorListObservable().subscribe(errorList => this.populateErrorList(errorList));
  }

  ngOnInit() {
    let worksheetModel = null;

    this.formItemControlService.setDiagnosisStatusObservable(diagnosisStatusEnum.OK, '');

    this.formItemControlService.resetFormItemDict();

    if (this.diagnosisStatus !== diagnosisStatusEnum.OK &&
        this.diagnosisStatusMessage.length > 0) {
        this.bShowStatusMessage = true;
    }

    this.tabsDataSource.push('Worksheet Data Entry');
    this.tabsDataSource.push('Generated Diagnosis');

    if (this.fcs != null) {
      if (this.fcs.year.length > 0 && this.fcs.organ.length > 0) {
        worksheetModel = this.fcs.getCurrentWorksheet();
        this.fcs.setFormLoadingObservable(true);
        this.fcs.setResultsLayoutSupportedObservable(worksheetModel.worksheetData.SupportResultsLayout);

        if (worksheetModel != null && worksheetModel.worksheetData != null) {
          this.populateItems('form', worksheetModel.worksheetData, null, 0, false, false);
        }

        if (this.formItems != null) {
          this.form = this.toFormGroup(this.formItems);
        }

        if (worksheetModel != null && worksheetModel.worksheetData != null) {
          this.populateItems('results', worksheetModel.worksheetData, null, 0, false, false);
        }

        if (this.resultItems != null) {
          this.resultsForm = this.toFormGroup(this.resultItems);
        }

        if (worksheetModel != null && worksheetModel.worksheetData != null) {
          this.populateItems('diagnosis', worksheetModel.worksheetData, null, 0, false, false);
        }

        if (this.diagnosisItems != null) {
          this.diagnosisForm = this.toFormGroup(this.diagnosisItems);
        }
        
        this.fcs.setFormLoadingObservable(false);
      }
    }

    worksheetModel.IsFirstUpdate = true;
    worksheetModel.ForceReset = false;
    this.formItemControlService.setFormLoadingObservable(true);
    // Update the worksheet to set the values to their initial states
    this.appInfoService.updateWorksheet(this.formItemControlService.token, worksheetModel).subscribe({
      next: (data: any[]) => {
        console.log('updateWorksheet: next');
        this.formItemControlService.AllowUpdates = false;
        this.formItemControlService.updateCurrentWorksheet(data);

        this.appInfoService.getStatus(this.formItemControlService.token).subscribe({
          next: (statusData: any[]) => {
            this.formItemControlService.setFormErrorObservable(false, '');
          },
          complete: () => {
            this.formItemControlService.AllowUpdates = true;
            this.formItemControlService.setFormLoadingObservable(false);
          }});
      },
      error: (data: any) => {
        // tslint:disable-next-line: max-line-length
        if (data != null) {
          if (data.status == 401) {
           this.formItemControlService.setFormErrorObservable(true, 'Logged off due to inactivity');
           this.formItemControlService.logoff();
          } else {
           this.formItemControlService.setFormErrorObservable(true, 'Failed to update the worksheet.  Error: ' + data.status + ', ' + data.statusText);
          }
        } else {
         this.formItemControlService.setFormErrorObservable(true, 'Failed to update the worksheet, unknown error');
        }

      },
      complete: () => {
        console.log('updateWorksheet: complete');
        this.formItemControlService.setFormLoadingObservable(false);
      }
    });
  }

  populateItems = (itemType: string,
                   worksheetData: any,
                   control: any,
                   depth: number,
                   bWSErrorsExist: boolean,
                   bWSWarningsExist: boolean) => {

    if (control === null) { // Top level
      let bErrorsExist = false;
      let bWarningsExist = false;

      if (worksheetData.ValidationErrors != null && worksheetData.ValidationErrors.length > 0) {
        worksheetData.ValidationErrors.forEach(e1 => {
          if (e1.Severity === 1) {
            bErrorsExist = true;
          } else if (e1.Severity === 0) {
            bWarningsExist = true;
          }
        });
      }

      if (itemType === 'form') {
        const title = new FormItemTitle({
          itemType,
          key: worksheetData.ID,
          label: worksheetData.Text,
          shortlabel: worksheetData.ShortText
        });

        this.formItems.push(title);

        if (worksheetData.Categories != null) {
          worksheetData.Categories.forEach(e => {
            const category = new FormItemCategory({
              itemType,
              key: e.ID,
              label: e.Text,
              altlabel: e.AltText,
              useAltText: e.UseAltText
            });

            this.formItems.push(category);
            this.formItemControlService.addFormItemToDict(category);

            e.Controls.forEach(e1 => {
              // Don't increment depth since these are not recursive elements
              this.populateItems(itemType, null, e1, depth, bErrorsExist, bWarningsExist);
            });
          });
        }
      } else if (itemType === 'results') {
        if (worksheetData.Results != null) {
          const results = new FormItemTitle({
            itemType,
            key: worksheetData.Results.ID,
            label: worksheetData.Results.Text
          });

          this.resultItems.push(results);

          worksheetData.Results.Controls.forEach(e1 => {
            // Don't increment depth since these are not recursive elements
            this.populateItems(itemType, null, e1, depth, bErrorsExist, bWarningsExist);
          });
        }
      } else if (itemType === 'diagnosis') {
        if (worksheetData.Diagnosis != null) {
          const diagnosis = new FormItemTitle({
            itemType,
            key: worksheetData.Diagnosis.ID,
            label: worksheetData.Diagnosis.Text
          });

          this.diagnosisItems.push(diagnosis);

          worksheetData.Diagnosis.Controls.forEach(e1 => {
             // Don't increment depth since these are not recursive elements
            this.populateItems(itemType, null, e1, depth, bErrorsExist, bWarningsExist);
          });
        }
      }
    } else {
      // process controls
      let ctrl = null;
      let bProcessChildren = true;
      let bCtrlAdded = false;

      switch (control.DataType) {
        case 'stringlist': {
          const optVals = new Array();
          const optStrs = new Array();

          const intVal = Number(control.Value);
          let selValue = '';

          control.ValueOptions.forEach(e2 => {
            const optVal = e2.Value;
            const optStr = e2.Text;

            optVals.push(optVal);
            optStrs.push(optStr);

            if (e2.Value === intVal) {
              selValue = e2.Text;
            }
          });

          ctrl = new FormItemDropdown({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.AltText,
            optionStrs: optStrs,
            optionVals: optVals,
            value: selValue,
            comment: control.Comment,
            isReadOnly: control.IsReadOnly,
            isEnabled: control.IsEnabled,
            isVisible: control.IsVisible,
            invalidValue: control.InvalidValue,
            useAltText: control.UseAltText,
            isTooltipDefined: control.IsTooltipDefined,
            depth,
            errorHint: control.ErrorHint
          });

          break;
        }

        case 'int': {
          ctrl = new FormItemIntTextBox({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.AltText,
            value: Number(control.Value),
            comment: control.Comment,
            isReadOnly: control.IsReadOnly,
            isEnabled: control.IsEnabled,
            isVisible: control.IsVisible,
            useAltText: control.UseAltText,
            invalidValue: control.InvalidValue,
            minValue: control.MinValue,
            maxValue: control.MaxValue,
            isTooltipDefined: control.IsTooltipDefined,
            depth,
            errorHint: control.ErrorHint
          });
          break;
        }

        case 'string': {
          let sizeHint = 'normal';
          let weightHint = 'normal';
          //let fgColorHint = 'black';

          control.ValueOptions.forEach(e2 => {
            sizeHint = e2.SizeHint.toLowerCase();
            weightHint = e2.WeightHint.toLowerCase();
            //fgColorHint = e2.FGColorHint.toLowerCase();
          });

          ctrl = new FormItemString({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.AltText,
            value: control.Value,
            comment: control.Comment,
            isReadOnly: control.IsReadOnly,
            isEnabled: control.IsEnabled,
            isVisible: control.IsVisible,
            useAltText: control.UseAltText,
            sizeHint,
            weightHint,
            depth,
            errorHint: control.ErrorHint
          });
          break;
        }

        case 'boollist': {
          ctrl = new FormItemBoolList({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.AltText,
            value: control.Value,
            comment: control.Comment,
            isReadOnly: control.IsReadOnly,
            isEnabled: control.IsEnabled,
            isVisible: control.IsVisible,
            useAltText: control.UseAltText,
            depth,
            errorHint: control.ErrorHint
          });

          bProcessChildren = false;

          let index = 0;

          this.formItems.push(ctrl);

          control.Controls.forEach(e2 => {

            const checkbox = new FormItemCheckbox({
              itemType,
              key: e2.ID,
              label: e2.Text,
              altlabel: e2.AltText,
              value: e2.Value,
              comment: e2.Comment,
              isReadOnly: e2.IsReadOnly,
              isEnabled: e2.IsEnabled,
              isVisible: e2.IsVisible,
              useAltText: e2.UseAltText,
              invalidValue: e2.InvalidValue,
              isTooltipDefined: e2.IsTooltipDefined,
              depth
            });
            index++;

            ctrl.children.push(checkbox);
            this.formItemControlService.addFormItemToDict(checkbox);
          });

          bCtrlAdded = true;
          break;
        }

        case 'intlist': {
          ctrl = new FormItemIntList({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.AltText,
            value: control.Value,
            comment: control.Comment,
            isReadOnly: control.IsReadOnly,
            isEnabled: control.IsEnabled,
            isVisible: control.IsVisible,
            useAltText: control.UseAltText,
            depth,
            errorHint: control.ErrorHint
          });

          bProcessChildren = false;

          let index = 0;

          this.formItems.push(ctrl);

          control.Controls.forEach(e2 => {
            const intBox = new FormItemIntTextBox({
              itemType,
              key: e2.ID,
              label: e2.Text,
              altlabel: e2.AltText,
              value: Number(e2.Value),
              comment: e2.Comment,
              isReadOnly: e2.IsReadOnly,
              isEnabled: e2.IsEnabled,
              isVisible: e2.IsVisible,
              useAltText: e2.UseAltText,
              invalidValue: e2.InvalidValue,
              minValue: e2.MinValue,
              maxValue: e2.MaxValue,
              isTooltipDefined: e2.IsTooltipDefined,
              depth,
              errorHint: e2.ErrorHint,
              inline: true
            });
            index++;

            ctrl.children.push(intBox);
            this.formItemControlService.addFormItemToDict(intBox);
          });

          bCtrlAdded = true;
          break;
        }

        case 'bool': {
          ctrl = new FormItemCheckbox({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.AltText,
            value: control.Value,
            comment: control.Comment,
            isReadOnly: control.IsReadOnly,
            isEnabled: control.IsEnabled,
            isVisible: control.IsVisible,
            useAltText: control.UseAltText,
            invalidValue: control.InvalidValue,
            isTooltipDefined: control.IsTooltipDefined,
            depth
          });
          break;
        }

        case 'action': {
          let widthHint = 'normal';
          let actionType = 'userdefined';
          let alertLevel = 'none';

          control.ValueOptions.forEach(e2 => {
            widthHint = e2.WidthHint.toLowerCase();
            actionType = e2.ActionModelType.toLowerCase();

            if (e2.AlertLevel != null) {
              alertLevel = e2.AlertLevel.toLowerCase();
            }
          });

          ctrl = new FormItemButton({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.AltText,
            comment: control.Comment,
            useAltText: control.UseAltText,
            isVisible: control.IsVisible,
            isTooltipDefined: control.IsTooltipDefined,
            widthHint,
            actionType,
            depth,
            alertLevel,
            bWorksheetErrorsExist: bWSErrorsExist,
            bWorksheetWarningsExist: bWSWarningsExist,
            formItemControlService: this.formItemControlService
          });
          break;
        }

        case 'multilinestring': {
          let heightHint = 'normal';
          //let fgColorHint = 'black';
          let showCopy = false;
          let showValidate = false;
          let alertLevel = 'none';

          control.ValueOptions.forEach(e2 => {
            heightHint = e2.HeightHint.toLowerCase();
            //fgColorHint = e2.FGColorHint.toLowerCase();
            showCopy = e2.ShowCopy;
            showValidate = e2.showValidate;

            if (e2.AlertLevel != null) {
              alertLevel = e2.AlertLevel.toLowerCase();
            }
          });

          ctrl = new FormItemMultiLineTextBox({
            itemType,
            key: control.ID,
            label: control.Text,
            altlabel: control.Text,
            value: control.Value,
            comment: control.Comment,
            heightHint,
            //fgColorHint,
            showCopy,
            showValidate,
            isReadOnly: control.IsReadOnly,
            isEnabled: control.IsEnabled,
            isVisible: control.IsVisible,
            invalidValue: control.InvalidValue,
            useAltText: control.UseAltText,
            isTooltipDefined: control.IsTooltipDefined,
            depth,
            errorHint: control.ErrorHint,
            alertLevel,
            bWorksheetErrorsExist: bWSErrorsExist,
            bWorksheetWarningsExist: bWSWarningsExist,
            formItemControlService: this.formItemControlService
          });
          break;
        }
      }

      if (ctrl != null && !bCtrlAdded) {
        if (itemType === 'form') {
          this.formItems.push(ctrl);
        } else if (itemType === 'results') {
          this.resultItems.push(ctrl);
        } else if (itemType === 'diagnosis') {
          this.diagnosisItems.push(ctrl);
        }

        // Register in the form item dictionary
        this.formItemControlService.addFormItemToDict(ctrl);
      }

      // Resursively process child controls
      if (bProcessChildren) {
        control.Controls.forEach(e3 => {
          // Increment depth since these are recursive elements
          this.populateItems(itemType, null, e3, depth + 1, bWSErrorsExist, bWSWarningsExist);
        });
      }
    }
  }

  toFormGroup(items: FormItemBase < any > []) {
    const group: any = {};

    items.forEach(item => {
      group[item.key] = item.required ? new FormControl(item.value || '', Validators.required)
        : new FormControl(item.value || '');
    });

    return new FormGroup(group);
  }

  onTabItemClick(e: any)
  {
    if (e.itemIndex === 0) {
      this.showWorksheetTab = true;
    } else {
      this.showWorksheetTab = false;
    }
  }

  isSplitLayoutSelected() {
    return this.formLayout === formLayoutEnum.Split;
  }

  isWorksheetLayoutSelected() {
    return this.formLayout === formLayoutEnum.Worksheet;
  }

  isDiagnosisLayoutSelected() {
    return this.formLayout === formLayoutEnum.Diagnosis;
  }

  is2PanelHorizontalLayoutSelected() {
    return this.formLayout === formLayoutEnum.DiagnosisHorizontal;
  }

  is2PanelVerticalLayoutSelected() {
    return this.formLayout === formLayoutEnum.DiagnosisVertical;
  }

  isFullScreenLayoutSelected() {
    return this.formLayout === formLayoutEnum.FullScreen;
  }

  populateErrorList(errorList: Array<any>) {
    this.errorList = errorList;

    if (this.errorList != null && this.errorList.length > 0) {
      this.errorListWindowSize = '1';
    } else {
      this.errorListWindowSize = '0';
    }
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.value);
  }

  onErrorLinkClicked(e, errorEntry) {
   const elt = document.getElementById(errorEntry.ControlID);
   if (elt != null) {
      elt.scrollIntoView();
    }

  }
}
